import { HugeiconsIcon } from "@hugeicons/react"
import { ComputerIcon, Moon02Icon, Sun03Icon } from "@hugeicons/core-free-icons"
import { useTheme, type ThemePreference } from "@/lib/contexts/ThemeContext"
import { cn } from "@/lib/utils"

const OPTIONS: { value: ThemePreference; label: string; icon: typeof Sun03Icon }[] = [
  { value: "light", label: "Light", icon: Sun03Icon },
  { value: "dark", label: "Dark", icon: Moon02Icon },
  { value: "system", label: "System", icon: ComputerIcon },
]

/** Paper segment: muted track, raised white thumb. `compact` hides labels (menus). */
export function ThemeSwitch({ compact = false, className }: { compact?: boolean; className?: string }) {
  const { preference, setTheme } = useTheme()
  return (
    <div role="radiogroup" aria-label="Theme" className={cn("flex rounded-lg bg-muted p-[3px]", className)}>
      {OPTIONS.map((opt) => {
        const on = preference === opt.value
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={on}
            aria-label={opt.label}
            title={opt.label}
            onClick={() => setTheme(opt.value)}
            className={cn(
              "inline-flex h-[26px] flex-1 items-center justify-center gap-1.5 rounded-md px-2.5 text-xs leading-4 transition-colors",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50",
              on
                ? "bg-card font-medium text-foreground shadow-[0_0_0_1px_rgb(9_9_11/0.05),0_1px_2px_rgb(0_0_0/0.06)] dark:bg-white/10 dark:shadow-none"
                : "text-foreground/60 hover:text-foreground",
            )}
          >
            <HugeiconsIcon icon={opt.icon} size={13} />
            {!compact && opt.label}
          </button>
        )
      })}
    </div>
  )
}
